// Year End Period Saga
import { all, call, fork, put, takeEvery } from "redux-saga/effects";

import {
  GET_YEAR_END_PERIOD_LIST,
  GET_YEAR_END_PERIOD_DETAILS,
  UPDATE_YEAR_END_PERIOD_DETAILS,
  CREATE_YEAR_END_PERIOD,
  DELETE_YEAR_END_PERIOD,
  GET_YEAR_END_PERIOD_INVOICE_LIST,
  GET_YEAR_END_PERIOD_INVOICE_ITEMS_LIST,
  GET_YEAR_END_PERIOD_PURCHASE_LIST,
  GET_YEAR_END_PERIOD_PURCHASE_ITEMS_LIST,
} from "./actionType";

import {
  getYearEndPeriodListSuccess,
  getYearEndPeriodListFailure,
  getYearEndPeriodDetailsSuccess,
  getYearEndPeriodDetailsFailure,
  updateYearEndPeriodDetailsSuccess,
  updateYearEndPeriodDetailsFailure,
  createYearEndPeriodSuccess,
  createYearEndPeriodFailure,
  deleteYearEndPeriodSuccess,
  deleteYearEndPeriodFailure,
  getYearEndPeriodInvoiceListSuccess,
  getYearEndPeriodInvoiceListFailure,
  getYearEndPeriodInvoiceItemsListSuccess,
  getYearEndPeriodInvoiceItemsListFailure,
  getYearEndPeriodPurchaseListSuccess,
  getYearEndPeriodPurchaseListFailure,
  getYearEndPeriodPurchaseItemsListSuccess,
  getYearEndPeriodPurchaseItemsListFailure,
} from "./action";

import {
  getYearEndPeriodListApi,
  getYearEndPeriodDetailsApi,
  updateYearEndPeriodDetailsApi,
  createYearEndPeriodApi,
  deleteYearEndPeriodApi,
  getYearEndPeriodInvoiceListApi,
  getYearEndPeriodInvoiceItemsListApi,
  getYearEndPeriodPurchaseListApi,
  getYearEndPeriodPurchaseItemsListApi,
} from "../../helpers/fakebackend_helper";

// Get Year End Period List
function* getYearEndPeriodList() {
  try {
    const response = yield call(getYearEndPeriodListApi);
    yield put(getYearEndPeriodListSuccess(response));
  } catch (error) {
    yield put(getYearEndPeriodListFailure(error));
  }
}

export function* watchGetYearEndPeriodList() {
  yield takeEvery(GET_YEAR_END_PERIOD_LIST, getYearEndPeriodList);
}

// Get Year End Period Details
function* getYearEndPeriodDetails({ payload }) {
  try {
    const response = yield call(getYearEndPeriodDetailsApi, payload);
    yield put(getYearEndPeriodDetailsSuccess(response));
  } catch (error) {
    yield put(getYearEndPeriodDetailsFailure(error));
  }
}

export function* watchGetYearEndPeriodDetails() {
  yield takeEvery(GET_YEAR_END_PERIOD_DETAILS, getYearEndPeriodDetails);
}

// Update Year End Period Details
function* updateYearEndPeriodDetails({ payload }) {
  try {
    const response = yield call(updateYearEndPeriodDetailsApi, payload);
    yield put(updateYearEndPeriodDetailsSuccess(response));
  } catch (error) {
    yield put(updateYearEndPeriodDetailsFailure(error));
  }
}

export function* watchUpdateYearEndPeriodDetails() {
  yield takeEvery(UPDATE_YEAR_END_PERIOD_DETAILS, updateYearEndPeriodDetails);
}

// Create Year End Period
function* createYearEndPeriod({ payload }) {
  try {
    const response = yield call(createYearEndPeriodApi, payload);
    yield put(createYearEndPeriodSuccess(response));
  } catch (error) {
    yield put(createYearEndPeriodFailure(error));
  }
}

export function* watchCreateYearEndPeriod() {
  yield takeEvery(CREATE_YEAR_END_PERIOD, createYearEndPeriod);
}

// Delete Year End Period
function* deleteYearEndPeriod({ payload }) {
  try {
    const response = yield call(deleteYearEndPeriodApi, payload);
    yield put(deleteYearEndPeriodSuccess(response));
  } catch (error) {
    yield put(deleteYearEndPeriodFailure(error));
  }
}

export function* watchDeleteYearEndPeriod() {
  yield takeEvery(DELETE_YEAR_END_PERIOD, deleteYearEndPeriod);
}

// Get Year End Period Invoice List
function* getYearEndPeriodInvoiceList({ payload }) {
  try {
    const response = yield call(getYearEndPeriodInvoiceListApi, payload);
    yield put(getYearEndPeriodInvoiceListSuccess(response));
  } catch (error) {
    yield put(getYearEndPeriodInvoiceListFailure(error));
  }
}

export function* watchGetYearEndPeriodInvoiceList() {
  yield takeEvery(
    GET_YEAR_END_PERIOD_INVOICE_LIST,
    getYearEndPeriodInvoiceList
  );
}

// Get Year End Period Invoice Items List
function* getYearEndPeriodInvoiceItemsList({ payload }) {
  try {
    const response = yield call(getYearEndPeriodInvoiceItemsListApi, payload);
    yield put(getYearEndPeriodInvoiceItemsListSuccess(response));
  } catch (error) {
    yield put(getYearEndPeriodInvoiceItemsListFailure(error));
  }
}

export function* watchGetYearEndPeriodInvoiceItemsList() {
  yield takeEvery(
    GET_YEAR_END_PERIOD_INVOICE_ITEMS_LIST,
    getYearEndPeriodInvoiceItemsList
  );
}

// Get Year End Period Purchase List
function* getYearEndPeriodPurchaseList({ payload }) {
  try {
    const response = yield call(getYearEndPeriodPurchaseListApi, payload);
    yield put(getYearEndPeriodPurchaseListSuccess(response));
  } catch (error) {
    yield put(getYearEndPeriodPurchaseListFailure(error));
  }
}

export function* watchGetYearEndPeriodPurchaseList() {
  yield takeEvery(
    GET_YEAR_END_PERIOD_PURCHASE_LIST,
    getYearEndPeriodPurchaseList
  );
}

// Get Year End Period Purchase Items List
function* getYearEndPeriodPurchaseItemsList({ payload }) {
  try {
    const response = yield call(getYearEndPeriodPurchaseItemsListApi, payload);
    yield put(getYearEndPeriodPurchaseItemsListSuccess(response));
  } catch (error) {
    yield put(getYearEndPeriodPurchaseItemsListFailure(error));
  }
}

export function* watchGetYearEndPeriodPurchaseItemsList() {
  yield takeEvery(
    GET_YEAR_END_PERIOD_PURCHASE_ITEMS_LIST,
    getYearEndPeriodPurchaseItemsList
  );
}

function* YearEndPeriodSaga() {
  yield all([
    fork(watchGetYearEndPeriodList),
    fork(watchGetYearEndPeriodDetails),
    fork(watchUpdateYearEndPeriodDetails),
    fork(watchCreateYearEndPeriod),
    fork(watchDeleteYearEndPeriod),
    fork(watchGetYearEndPeriodInvoiceList),
    fork(watchGetYearEndPeriodInvoiceItemsList),
    fork(watchGetYearEndPeriodPurchaseList),
    fork(watchGetYearEndPeriodPurchaseItemsList),
  ]);
}

export default YearEndPeriodSaga;
